import { IAxiosResponseData } from '@/store';
import { axios } from '@/nmb/request';

const api = `api/Mysoft.Calendar.Common.AppServices.CalendarCommonAppService/`;

// 获取日历事件列表
export const getCalendarEventsByUser = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetCalendarEventsByUser`, params);

export const GetSyncMemberMessages = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetSyncMemberMessages`, params);

export const ScheduleInvitationAgreed = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}ScheduleInvitationAgreed`, params);

export const ScheduleInvitationRefused = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}ScheduleInvitationRefused`, params);

// 获取单位
export const getBusinessUnitList = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetBusinessUnitList`, params);
// 获取单位下的成员
export const getDepartmentUsers = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetDepartmentUsers`, params);
// 通过用户GUID获取关注的人列表（日历视图）
export const getFollowedUsers = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetFollowedUsers`, params);
